import React from "react";

function RegisterPage(props) {

    return <div className="Content RegisterPage">
        <h1>Register Page</h1>
    </div>;
}

export default RegisterPage;